import { api } from './apiClient';

export interface HsnCode {
  id: number;
  hsn_code: string;
  description: string;
  gst_rate: number;
  category?: string;
}

interface HsnCodesResponse {
  hsnCodes: HsnCode[];
  count: number;
}

interface HsnCodeResponse {
  hsnCode: HsnCode;
}

export const hsnService = {
  /**
   * Get all HSN codes
   */
  getAll: async (params?: { category?: string; search?: string; limit?: number }): Promise<HsnCodesResponse> => {
    return api.get<HsnCodesResponse>('/hsn', { params });
  },

  /**
   * Search HSN codes
   */
  search: async (query: string, limit = 20): Promise<HsnCodesResponse> => {
    return api.get<HsnCodesResponse>('/hsn/search', { params: { q: query, limit } });
  },

  /**
   * Get HSN code by ID
   */
  getById: async (id: number): Promise<HsnCodeResponse> => {
    return api.get<HsnCodeResponse>(`/hsn/${id}`);
  },

  /**
   * Create new HSN code
   */
  create: async (data: { hsn_code: string; description: string; gst_rate: number; category?: string }): Promise<HsnCodeResponse> => {
    return api.post<HsnCodeResponse>('/hsn', data);
  },
};
